<template>
  <div class="history">
    <h1 class="header-title">History</h1>
    <div class="loading-history" v-loading="loading" element-loading-text="Loading the history...">
      <ol class="history-list">
        <history-item 
          v-for="(event) in unconfirmeds" 
          :key="event.hash"
          :title="event.title"
          :message="event.message"
          :time="event.calcTime"
          :score="event.score"
          :status="event.status" >
        </history-item>
        <history-item 
          v-for="(event) in timeline" 
          :key="event.hash"
          :title="event.title"
          :message="event.message"
          :time="event.calcTime"
          :score="event.score">
        </history-item>
      </ol>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import EventBus from '../Buss/EventBus';
import nem from '../../static/js/index';
import '../../node_modules/moment/locale/en-gb';

const HistoryItem = () => import('./HistoryItem');
const format = nem.utils.format;

export default {
  data() {
    return {
      count: 0,
      timeline: [],
      unconfirmeds: [],
      loading: true,
      loadToTimeline: true,
      assetAddress: this.$route.params.address,
    };
  },
  components: {
    HistoryItem,
  },
  methods: {
    getObject(data) {
      if (data.transaction.type === 257) {
        // creation message
        return this.getCreationObject(data);
      } else if (data.transaction.type === 4097) {
        // claim
        return this.getClaimObject(data);
      } else if (data.transaction.type === 4100) {
        if (data.transaction.otherTrans.type === 257) {
          // update
          return this.getUpdateObject(data);
        } else if (data.transaction.otherTrans.type === 4097) {
          // transfer
          return this.getTransferObject(data);
        }
      }
      // we don't have transaction type ${data.transaction.type} declared
      return null;
    },
    getCreationObject(data) {
      const time = data.transaction.timeStamp;
      return {
        hash: data.meta.hash.data,
        title: 'Creation',
        icon: 'tag',
        color: 'blue',
        calcTime: this.calculateTime(time),
        now: moment(format.nemDate(time)).fromNow(),
        time: moment(format.nemDate(time)).format('MMMM Do YYYY, h:mm:ss a'),
        message: 'This is where everything started.',
      };
    },
    getClaimObject(data) {
      const time = data.transaction.timeStamp;
      return {
        hash: data.meta.hash.data,
        title: 'Claim',
        icon: 'check-circle',
        color: 'green',
        calcTime: this.calculateTime(time),
        now: moment(format.nemDate(time)).fromNow(),
        time: moment(format.nemDate(time)).format('MMMM Do YYYY, h:mm:ss a'),
        message: 'The first time the asset has been claimed.',
        status: data.status,
      };
    },
    getUpdateObject(data) {
      const time = data.transaction.otherTrans.timeStamp;
      const trans = JSON.parse(
        format.hexToUtf8(
          data.transaction.otherTrans.message.payload));

      if (trans.T === 0) {
        // memo
        return {
          hash: data.meta.innerHash.data,
          title: 'Memo',
          icon: 'edit',
          color: 'blue',
          calcTime: this.calculateTime(time),
          now: moment(format.nemDate(time)).fromNow(),
          time: moment(format.nemDate(time)).format('MMMM Do YYYY, h:mm:ss a'),
          message: trans.U.M,
          status: data.status,
        };
      } else if (trans.T === 1) {
        // review
        return {
          hash: data.meta.innerHash.data,
          title: 'Review',
          icon: 'like',
          color: 'blue',
          calcTime: this.calculateTime(time),
          now: moment(format.nemDate(time)).fromNow(),
          time: moment(format.nemDate(time)).format('MMMM Do YYYY, h:mm:ss a'),
          message: trans.U.M,
          score: trans.U.S,
          status: data.status,
        };
      } else if (trans.T === 2) {
        // repair
        let category;
        if (trans.U.C === 'c') {
          category = 'Watch Case';
        } else if (trans.U.C === 'g') {
          category = 'Glass';
        } else if (trans.U.C === 's') {
          category = 'Strap';
        }
        return {
          hash: data.meta.innerHash.data,
          title: 'Repaire',
          icon: 'tool',
          color: 'blue',
          calcTime: this.calculateTime(time),
          now: moment(format.nemDate(time)).fromNow(),
          time: moment(format.nemDate(time)).format('MMMM Do YYYY, h:mm:ss a'),
          message: `Repaired the ${category}
                    ${trans.U.M}`,
          status: data.status,
        };
      } else if (trans.T === 3) {
        // lost $ found
        if (trans.U.T === 'l') {
          return {
            hash: data.meta.innerHash.data,
            title: 'Asset Lost',
            icon: 'frown',
            color: 'red',
            calcTime: this.calculateTime(time),
            now: moment(format.nemDate(time)).fromNow(),
            time: moment(format.nemDate(time)).format('MMMM Do YYYY, h:mm:ss a'),
            message: trans.U.M,
            status: data.status,
          };
        } else if (trans.U.T === 'f') {
          return {
            hash: data.meta.innerHash.data,
            title: 'Asset found',
            icon: 'smile',
            color: 'green',
            calcTime: this.calculateTime(time),
            now: moment(format.nemDate(time)).fromNow(),
            time: moment(format.nemDate(time)).format('MMMM Do YYYY, h:mm:ss a'),
            message: trans.U.M,
            status: data.status,
          };
        }
      }
      // data structure did not found on the logic
      return null;
    },
    getTransferObject(data) {
      const trans = data.transaction.otherTrans;
      return {
        hash: data.meta.innerHash.data,
        title: 'Transfer of Ownership',
        icon: 'usergroup-add',
        color: 'blue',
        calcTime: this.calculateTime(trans.timeStamp),
        now: moment(format.nemDate(trans.timeStamp)).fromNow(),
        time: moment(format.nemDate(trans.timeStamp)).format('MMMM Do YYYY, h:mm:ss a'),
        message: `This asset has been transfered from ${trans.modifications[1].cosignatoryAccount.slice(0, 8)} to ${trans.modifications[0].cosignatoryAccount.slice(0, 8)}.`,
        status: data.status,
      };
    },
    calculateTime(timeStamp) {
      // if the time difference just 1 day it will show like 2 hour ago format
      if (moment(format.nemDate(timeStamp)).isAfter(moment().subtract(1, 'days'))) {
        return moment(format.nemDate(timeStamp)).fromNow();
      }
      return moment(format.nemDate(timeStamp)).format('MMMM Do YYYY, h:mm:ss a');
    },
    setTimeline(history) {
      for (let i = 0; i < history.data.length; i += 1) {
        this.timeline.push(this.getObject(history.data[i]));
      }
      this.loading = false;
    },
    newHistory(newHist) {
      let contain = false;
      // prevent duplicate update confirmed
      for (let i = 0; i < this.timeline.length; i += 1) {
        if (this.timeline[i].hash === newHist.meta.hash.data) {
          contain = true;
        }
      }
      if (contain === false) {
        // remove 1 unconfirmed
        this.unconfirmeds.pop();
        // add to timeline
        const object = this.getObject(newHist);
        // make sure for the confirmed transaction to always use hash, not innerHash
        object.hash = newHist.meta.hash.data;
        this.timeline.unshift(object);
      }
    },
    newUnconfirmed(newUnconf) {
      let contain = false;
      // prevent duplicate unconfirmed
      for (let i = 0; i < this.unconfirmeds.length; i += 1) {
        if (this.unconfirmeds[i].hash === newUnconf.meta.innerHash.data) {
          contain = true;
          break;
        }
      }
      if (contain === false) {
        this.unconfirmeds.unshift(this.getObject(newUnconf));
      }
    },
    connect(connector) {
      const that = this;
      const nemSocket = nem.com.websockets;
      // to close the connector before leaving the route
      EventBus.$on('close', () => {
        connector.close();
      });
      // display this message once
      if (that.count === 0) {
        that.$message({
          message: 'Connecting to the blockchain..',
          type: 'info',
          showClose: true,
        });
      }
      return connector.connect().then(() => {
        // here we are connected to the NIS
        that.$message({
          message: 'Connection established',
          type: 'success',
          showClose: true,
        });
        // we subscribe to errors channel first
        nemSocket.subscribe.errors(connector, (res) => {
          that.$notify({
            message: JSON.stringify(res),
            type: 'error',
          });
        });

        // Subscribe to recent transactions channel
        nemSocket.subscribe.account.transactions.recent(connector, (trs) => {
          // prevent duplicate timelines
          if (that.loadToTimeline) {
            that.loadToTimeline = false;
            that.setTimeline(trs);
          }
        });

        // Subscribe to account data channel
        nemSocket.subscribe.account.data(connector, (res) => {
          if (res.meta.cosignatories.length > 0) {
            if (that.authPP === res.meta.cosignatories[0].publicKey) {
              // auth is the owner of the product
              that.$emit('changeHide', false);
            } else {
              that.$emit('changeHide', true);
            }
          }
        });

        // Subscribe to unconfirmed transactions channel
        nemSocket.subscribe.account.transactions.unconfirmed(connector, (res) => {
          const trs = res;
          trs.status = 'unconfirmed';
          that.newUnconfirmed(trs);
        });

        // Subscribe to unconfirmed transactions channel
        nemSocket.subscribe.account.transactions.confirmed(connector, (res) => {
          that.newHistory(res);
        });

        // Request account data
        nemSocket.requests.account.data(connector);

        // Request recent transactions
        nemSocket.requests.account.transactions.recent(connector);
      }, (err) => { // eslint-disable-line  padded-blocks
        that.$notify({
          message: 'Connection Error',
          type: 'error',
          duration: 0,
        });
        // Try to reconnect
        that.count += 1;
        // if (that.count < that.MAX_NODES * 2) { // stop recon if every node have beed tried twice
        that.reconnect(connector); // eslint-disable-line no-use-before-define
        // }
      }).catch((err) => {
        // Try to reconnect
        that.reconnect();
        that.$notify({
          message: JSON.stringify(err),
          type: 'error',
          duration: 0,
        });
      });
    },
    reconnect(connector) {
      const that = this;
      const nemSocket = nem.com.websockets;
      let endPointIndex = that.endPointIndex;
      // to close the connector before leaving the route
      EventBus.$on('close', () => {
        connector.close();
      });
      endPointIndex += 1;
      if (endPointIndex >= that.MAX_NODES) {
        endPointIndex = 0;
      }
      that.$store.commit('SET_ENDINDEX', endPointIndex);

      // Replace connector with a new endpoint
      const newConnector = nemSocket.connector.create(
        that.$store.getters.getEndpoints.websocket[endPointIndex],
        that.assetAddress);
      that.$message({
        message: 'Trying to reconnect....',
        type: 'info',
        showClose: true,
      });
      // Try to establish a connection
      that.connect(newConnector);
    },
  },
  computed: {
    endPointIndex() {
      return this.$store.getters.getEndpointIndex;
    },
    authPP() {
      return this.$store.getters.getAuth.PP;
    },
    MAX_NODES() {
      return this.$store.getters.getEndpoints.websocket.length;
    },
  },
  watch: {
  },
  created() {
    const that = this;

    moment.locale('en-gb');

    // get unconfirmed product
    nem.com.requests.account.transactions.unconfirmed(
    this.$store.getters.getEndpoints.web[that.endPointIndex],
    this.assetAddress)
    .then((unconf) => {
      for (let i = unconf.data.length - 1; i >= 0; i -= 1) {
        const trs = unconf.data[i];
        trs.status = 'unconfirmed';
        trs.meta.innerHash = { data: trs.meta.data };
        that.newUnconfirmed(trs);
      }
    }, (e) => {
      that.$notify({
        message: e,
        type: 'error',
        duration: 0,
      });
    });

    // Create a connector object
    const connector = nem.com.websockets.connector.create(
      this.$store.getters.getEndpoints.websocket[that.endPointIndex],
      this.assetAddress);

    that.connect(connector);
  },
  beforeRouteLeave(to, from, next) {
    EventBus.$emit('close');
    next();
  },
};
</script>

<style lang="scss">
  .history {
    margin-bottom: 44px;
    .header-title {
      border-bottom: 1px solid#d2d2d2;
      max-width: 720px;
      margin: 35px auto;
    }
    .loading-history {
      .history-list {
        padding: 0;
      }
    }
  }
</style>




// WEBPACK FOOTER //
// History.vue?0a36ac4e